import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Sidebar from "./components/sidebar/Sidebar";
import Home from "./pages/home/Home";
import Reports from "./pages/reports/Reports";
import Searches from "./pages/searches/Searches";
import "./App.scss";
import Header from "./components/header/Header";
import { Result } from "./components/result/Result";
import { useEffect, useState } from "react";
import { Status } from "./pages/status/Status";

function App() {
  const [searchesRows, setSearchesRows] = useState([]);
  const [reportsRows, setReportsRows] = useState([]);

  useEffect((_) => {
    fetch(
      "https://nameless-ridge-78695.herokuapp.com/api/searches/admin/allposts"
    )
      .then((res) => res.json())
      .then((data) => {
        setSearchesRows(
          data.reverse().map((item) => ({
            id: item._id,
            img: `https://firebasestorage.googleapis.com/v0/b/gproject-71212.appspot.com/o/images%2F${item.img}?alt=media&token=d33c497f-509e-46db-a0c7-19994333034c`,
            title: `طفل تائه من ${item.address}`,
            name: item.name || "-",
            date: item.createdAt.split("T")[0],
            status: item.status,
          }))
        );
      });

    fetch(
      "https://nameless-ridge-78695.herokuapp.com/api/reports/admin/allreports"
    )
      .then((res) => res.json())
      .then((data) => {
        setReportsRows(
          data.reverse().map((item) => ({
            id: item._id,
            img: `https://firebasestorage.googleapis.com/v0/b/gproject-71212.appspot.com/o/images%2F${item.img}?alt=media&token=d33c497f-509e-46db-a0c7-19994333034c`,
            title: `طفل تائه من ${item.address}`,
            name: item.name || "-",
            date: item.createdAt.split("T")[0],
            status: item.status,
          }))
        );
      });
  }, []);

  return (
    <Router>
      <div className="app">
        <Sidebar />
        <main>
          <Header />
          <Routes>
            <Route path="/">
              <Route
                index
                element={
                  <Home
                    reportsRows={reportsRows.slice(0, 2)}
                    searchesRows={searchesRows.slice(0, 2)}
                    searches={searchesRows.length}
                    reports={reportsRows.length}
                  />
                }
              />
              <Route path="reports">
                <Route index element={<Reports rows={reportsRows} />} />
                <Route path="result/:id" element={<Result />} />
                <Route path="status/:id" element={<Status />} />
              </Route>

              <Route path="searches">
                <Route index element={<Searches rows={searchesRows} />} />
                <Route path="result/:id" element={<Result />} />
                <Route path="status/:id" element={<Status />} />
              </Route>
            </Route>
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
